import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";


const PrivateRoute = ({ children }) => {

  const isAuthenticated = () => {
    const token = Cookies.get('token'); // Assuming you're using js-cookie for cookie management

    if (!token) {
      return false; // No token found, user is not authenticated
    }

    try {
      // Decode the JWT token to extract expiration date
      const decodedToken = jwtDecode(token);
      // Check if token is expired
      return decodedToken.exp > Date.now() / 1000;
    } catch (error) {
      return false; // Token is invalid or expired
    }
  };

  const isAuth = isAuthenticated()

  return isAuth ? children : <Navigate to="/login" />;

}

export default PrivateRoute
